<template>
  <v-dialog v-model="showDialog" width="500px">
    <v-card class="search-modal">
      <h2 class="mb-3">Search & Add Lessees</h2>
      <p class="mb-6">Up to 6 lessees are accepted.</p>
      <v-form class="search-form" @submit.prevent="search">
        <v-text-field
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="membershipID"
          label="Search Member ID"
        ></v-text-field>
      </v-form>
      <p v-if="!searchResults.length && hasSearched">No users found</p>
      <v-data-table
        v-if="searchResults.length"
        :headers="headers"
        :items="searchResults"
        hide-default-footer
        hide-default-header
      >
        <template v-slot:item="row">
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
          <tr v-bind="attrs" v-on="on">
            <td>{{ row.item.firstName }} {{ row.item.lastName }}</td>
            <td>{{ row.item.memberId }}</td>
            <td>                
                  <font-awesome-icon icon="id-card" :color="row.item.canBeCoowner == false ? 'red' : 'green'"/>
                </td>
            <td>
                      <a
                        :class="{ 'disabled-link': isValidCoOwner(row.item) == false }"
                        v-on:click="addLessee(row.item)"
                      >
                        <font-awesome-icon icon="plus" :color="isValidCoOwner(row.item) ? 'blue' : 'gray'" />
                      </a>            
                </td>
          </tr>
            </template>    
            <span v-if="isValidCoOwner(row.item) == false">This person does not meet the requirements to be a lessee.</span>
            <span v-else>This person can be added as a lessee.</span>
          </v-tooltip>  
        </template>
      </v-data-table>
      <p class="mb-6" v-if="selectedLessees.length">- or -</p>
      <v-btn
        color="primary"
        class="white--text"
        block
        :disabled="!selectedLessees.length"
        v-on:click="submit"
        >Continue</v-btn
      >
      <div v-if="selectedLessees.length">
        <h2 class="mt-8">Added Lessees</h2>
        <v-data-table
          :headers="headers"
          :items="selectedLessees"
          hide-default-footer
          hide-default-header
        >
          <template v-slot:item="row">
            <tr v-bind="attrs" v-on="on">
              <td>{{ row.item.firstName }} {{ row.item.lastName }}</td>
              <td>{{ row.item.memberId }}</td>
              <td>
                <a v-on:click="removeLessee(row.item)">
                  <font-awesome-icon icon="minus" />
                </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <p class="mt-8">
        Lessee will be emailed a link to sign the registration document.
        Registration is not complete until lessee has signed. Lessees must be
        registered, active ASCA members.
      </p>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import { debounce } from "throttle-debounce";
import registerLeaseService from "@/services/portal/registerLeaseService";

import { LesseeResult } from "@/types/portal/Lease";

export default Vue.extend({
  name: "AddLesseeModal",
  data: function () {
    return {
      showDialog: this.$props.lesseeDialog,
      hasSearched: false,
      searchResults: [] as any[],
      selectedLessees: [...this.$props.lesseeInfo],
      membershipID: "",
      headers: [
        { text: "Name", align: "left", value: "name" },
        { text: "Membership ID", align: "left", value: "memberId" },
      ],
    };
  },
  watch: {
    lesseeDialog: function (newVal: boolean) {
      if (!newVal) {
        this.membershipID = "";
        this.hasSearched = false;
        this.searchResults = [] as LesseeResult[];
      }
      this.showDialog = newVal;
    },
    showDialog: function (newVal: boolean) {
      //this is handling situation when the user closes dialog
      //by clicking outside of it
      if (!newVal) {
        this.membershipID = "";
        this.hasSearched = false;
        this.searchResults = [] as LesseeResult[];
        (this.selectedLessees = [...this.$props.lesseeInfo]),
          this.toggleLesseeModal();
      }
    },
    membershipID: {
      handler: debounce(
        1000,
        function (this: any, newVal: string, oldVal: string) {
          if (newVal === oldVal || !newVal) return;
          this.search();
        }
      ),
      deep: true,
    },
  },
  methods: {
    search: function () {
      this.hasSearched = false;
      registerLeaseService
        .searchLessee(this.membershipID)
        .then((response: LesseeResult[]) => {
          this.hasSearched = true;
          this.searchResults = response;
        });
    },
     isValidCoOwner(coowner: LesseeResult) {
      return coowner.canBeCoowner;
    },
    addLessee(row: LesseeResult) {
      if (!row.canBeCoowner) return;
      if (this.selectedLessees.length >= 6) return;
      if (this.selectedLessees.some((el) => el.personId === row.personId))
        return;
      this.searchResults = [] as LesseeResult[];
      this.hasSearched = false;
      this.membershipID = "";
      let item = {
        firstName: row.firstName,
        lastName: row.lastName,
        memberId: row.memberId,
        personId: row.personId,
        isPrimary: false,
      };
      this.selectedLessees.push(item);
    },
    removeLessee(row: LesseeResult) {
      this.selectedLessees.splice(this.selectedLessees.indexOf(row), 1);
      this.changeLesseeInfo(this.selectedLessees);
    },
    submit() {
      this.changeLesseeInfo(this.selectedLessees);
      this.showDialog = false;
    },
  },
  props: {
    changeLesseeInfo: Function,
    lesseeDialog: Boolean,
    toggleLesseeModal: Function,
    lesseeInfo: Array,
  },
});
</script>